class ModelList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(el => {
        this.listeners.add(el, 'click', this.handleTrigger)
      })
    }

    if (this.els?.filter?.exists) {
      this.handleFilter = this.handleFilter.bind(this)

      this.els.filter.elements.forEach(filterEl => {
        this.listeners.add(filterEl, `click`, this.handleFilter)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.ariaHidden = panelEl.dataset.tab !== triggerEl.dataset.tab
    })
    this.els.trigger.elements.forEach(trigger => {
      trigger.ariaPressed = trigger.dataset.tab === triggerEl.dataset.tab
    })
  }

  handleFilter (event) {
    const filterEl = event.target.closest(this.els?.filter?.selector)
    if (!filterEl) return

    filterEl.ariaPressed = filterEl.ariaPressed === 'true' ? 'false' : 'true'
  }
}

if (!customElements.get('model-list')) {
  customElements.define('model-list', ModelList)
}
